
export const sFechaPublicacion = '2026-11-03T19:01:54.4031100-06:00';
export const sVersion = 'vf1.1.611031901';
            